import queryClient from "~/lib/cache/queryClient";
import type { CollectionNames } from "~/types";

/**
 * Clears specific items from the TanStack Query cache based on a key prefix
 * @param keyToInvalidate - The key prefix to invalidate
 */
export const clearSpecificCache = (keyToInvalidate: string) => {
  queryClient.invalidateQueries({
    predicate: (query) => {
      const queryKey = query.queryKey;
      if (Array.isArray(queryKey)) {
        return queryKey.some(
          (key) => typeof key === "string" && key.startsWith(keyToInvalidate)
        );
      }
      return false;
    },
  });
};

/**
 * Clears all items from the TanStack Query cache that match a collection
 * @param collection - The collection to clear from the cache
 * @returns void
 * @example
 * clearAllCollectionCache("invitations");
 */
export const clearAllCollectionCache = (collection: CollectionNames) => {
  queryClient.invalidateQueries({
    predicate: (query) => {
      const queryKey = query.queryKey;
      if (Array.isArray(queryKey)) {
        return queryKey.some(
          (key) => typeof key === "string" && key.includes(collection)
        );
      }
      return false;
    },
  });
};

/**
 * Clears all items from the TanStack Query cache
 */
export const clearAllCache = () => {
  queryClient.clear();
};
